"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.programLanguages = exports.activityCategories = exports.patientProgramAppElementSettings = exports.patientProgramElementGroups = exports.activityLabels = exports.notificationKeys = void 0;
var constants_1 = require("../youwell-common/constants");
exports.notificationKeys = {
    unreadMessages: 'unreadMessages',
    overdueTasks: 'overdueTasks',
    program: 'program',
};
exports.activityLabels = {
    header: 'header',
    menu: {
        home: 'menu/home',
        calendar: 'menu/calendar',
        videos: 'menu/videos',
        profile: 'menu/profile',
        chat: 'menu/chat',
        videochat: 'menu/videochat',
        logout: 'menu/logout',
        favourites: 'menu/favourites',
        appPage: 'menu/app',
        activityDiary: 'menu/activityDiary',
        page: 'menu/page',
        prints: 'menu/prints',
        feedback: 'menu/feedback',
        org: 'menu/org',
        consent: 'menu/consent',
    },
    dashboard: {
        questionnaires: 'dashboard/questionnaires',
        calendar: 'dashboard/calendar',
        module: 'dashboard/module',
        introModule: 'dashboard/introModule',
        currentModule: 'dashboard/currentModule',
        appointment: 'dashboard/appointment',
        exit: 'exit',
    },
    moduleProgress: {
        link: 'moduleProgress',
    },
    breadcrumb: {
        link: 'breadcrumb',
        home: 'breadcrumb/home',
        module: 'breadcrumb/module',
        task: 'breadcrumb/task',
    },
    sidemenu: {
        link: 'sidemenu',
    },
    taskPreview: {
        goToTask: 'taskPreview/goToTask',
    },
};
exports.patientProgramElementGroups = __assign(__assign({}, constants_1.systemElementGroups), { default: 'Default', appointment: 'Appointment' });
exports.patientProgramAppElementSettings = {
    header: 'header',
    intro: 'intro',
    dashboardInfo: 'info',
    worksheet: 'worksheet',
    hidden: 'hidden',
};
exports.activityCategories = {
    physical: 'PhysicalTraining',
    mental: 'MentalTraining',
    dailyRoutine: 'DailyRoutine',
};
exports.programLanguages = [
    { code: 'no', name: 'Norsk' },
    // { code: 'en', name: 'English' },
    { code: 'ua', name: 'Українська' },
    { code: 'ru', name: 'Pусский' },
];
